import { Alert, AlertTitle } from "@mui/material";
import type { ApiError } from "@entrilia/shared/api/types";

interface Props {
  apiError: ApiError;
}

const LoadingFailedAlert = ({ apiError }: Props) => {
  return (
    <Alert severity="error" sx={{ maxWidth: "32rem" }}>
      <AlertTitle>Loading failed - status {apiError.code}</AlertTitle>
      {apiError.message}
    </Alert>
  );
};

export default LoadingFailedAlert;
